import { SvgIcon } from "@mui/material";
import React from "react";

/**
 * Command Center icon — tactical radar display with:
 * - Outer border ring
 * - Inner target ring
 * - Cardinal crosshair ticks (between rings)
 * - Radar sweep wedge
 * - Center hub dot
 * - Three target blip dots
 */
const CommandCenterIcon = ({ fill }) => {
  return (
    <SvgIcon>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Outer border ring (r=8.5 outer / r=7.5 inner) */}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 1.5 A8.5 8.5 0 1 0 10 18.5 A8.5 8.5 0 1 0 10 1.5 Z
             M10 2.5 A7.5 7.5 0 1 1 10 17.5 A7.5 7.5 0 1 1 10 2.5 Z"
          fill={fill}
        />

        {/* Inner target ring (r=5.0 outer / r=4.3 inner) */}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 5 A5 5 0 1 0 10 15 A5 5 0 1 0 10 5 Z
             M10 5.7 A4.3 4.3 0 1 1 10 14.3 A4.3 4.3 0 1 1 10 5.7 Z"
          fill={fill}
        />

        {/* Cardinal crosshair ticks — North (between inner ring edge and outer ring edge) */}
        <rect x="9.65" y="2.6" width="0.7" height="2.3" rx="0.35" fill={fill} />
        {/* South */}
        <rect
          x="9.65"
          y="15.1"
          width="0.7"
          height="2.3"
          rx="0.35"
          fill={fill}
        />
        {/* West */}
        <rect x="2.6" y="9.65" width="2.3" height="0.7" rx="0.35" fill={fill} />
        {/* East */}
        <rect
          x="15.1"
          y="9.65"
          width="2.3"
          height="0.7"
          rx="0.35"
          fill={fill}
        />

        {/* Radar sweep wedge
            From center(10,10) → upper-right at 315° → right at 0°
            315°: x=10+7.5*cos(-45°)=15.30, y=10+7.5*sin(-45°)=4.70
            0°:   x=10+7.5=17.5,             y=10
            arc: large-arc=0, sweep=1 (clockwise) */}
        <path
          d="M10 10 L15.3 4.7 A7.5 7.5 0 0 1 17.5 10 Z"
          fill={fill}
          opacity="0.55"
        />

        {/* Sweep leading edge — bold line from center at 315° */}
        <rect
          x="9.65"
          y="2.4"
          width="0.7"
          height="7.6"
          rx="0.35"
          fill={fill}
          transform="rotate(45, 10, 10)"
        />

        {/* Center hub */}
        <circle cx="10" cy="10" r="1.3" fill={fill} />

        {/* Target blip 1 — upper right, between rings */}
        <circle cx="13.4" cy="6.2" r="0.72" fill={fill} />

        {/* Target blip 2 — left side, mid quadrant */}
        <circle cx="6.2" cy="8.3" r="0.72" fill={fill} />

        {/* Target blip 3 — lower right, near outer ring */}
        <circle cx="12.6" cy="13.8" r="0.72" fill={fill} />
      </svg>
    </SvgIcon>
  );
};

export default CommandCenterIcon;
